var _style, _ellipse, _ellipse2, _g, _path, _path2, _path3, _polygon, _rect, _ellipse3, _path4, _path5, _g2, _path6, _path7, _path8, _path9, _circle, _g3, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g4, _g5, _path17, _path18, _path19, _g6, _path20, _g7, _g8, _g9, _path21, _g10, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAbout2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1100 800",
    style: {
      enableBackground: "new 0 0 1100 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0F0F0;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#C6E7F4;}\n\t.st3{fill:#19406C;}\n\t.st4{opacity:0.07;fill:#24BCB0;}\n\t.st5{fill:url(#SVGID_1_);}\n\t.st6{fill:url(#SVGID_2_);}\n\t.st7{fill:#24BCB0;}\n\t.st8{fill:url(#SVGID_3_);}\n\t.st9{fill:url(#SVGID_4_);}\n\t.st10{opacity:0.19;}\n\t.st11{fill:#3E1B75;}\n\t.st12{opacity:0.37;}\n\t.st13{opacity:0.19;fill:#3E1B75;}\n\t.st14{fill:#AFDDF9;}\n\t.st15{fill:url(#SVGID_5_);}\n\t.st16{fill:none;stroke:#B8DDF4;stroke-width:0.3782;stroke-miterlimit:10;}\n\t.st17{fill:none;stroke:#230B38;stroke-width:0.8171;stroke-miterlimit:10;}\n\t.st18{fill:#19A396;}\n\t.st19{fill:url(#SVGID_6_);}\n\t.st20{fill:url(#SVGID_7_);}\n\t.st21{fill:url(#SVGID_8_);}\n\t.st22{fill:url(#SVGID_9_);}\n\t.st23{fill:url(#SVGID_10_);}\n\t.st24{fill:#FFAD97;}\n\t.st25{fill:#FCC1BB;}\n\t.st26{fill:#020202;}\n\t.st27{fill:#25084F;}\n\t.st28{fill:#FFD1CF;}\n\t.st29{fill:#050505;}\n\t.st30{fill:#00338C;}\n\t.st31{fill:#0E0F0F;}\n\t.st32{fill:#270C5B;}\n\t.st33{opacity:0.5;}\n\t.st34{fill:#BCD2DC;}\n\t.st35{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.4301;stroke-miterlimit:10;}\n\t.st36{opacity:0.8;}\n\t.st37{fill:#98E5DE;}\n\t.st38{fill:url(#SVGID_11_);}\n\t.st39{display:none;}\n\t.st40{display:inline;fill:#19A396;}\n\t.st41{display:inline;fill:#24BCB0;}\n\t.st42{display:inline;fill:#116881;}\n\t.st43{display:inline;fill:#19406C;}\n\t.st44{display:inline;fill:#25084F;}\n\t.st45{display:inline;fill:#FCC1BB;}\n\t.st46{display:inline;fill:#F0F0F0;}\n\t.st47{display:inline;fill:#3E1B75;}\n\t.st48{display:inline;fill:#FFD1CF;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 953.49,
    cy: 778.45,
    rx: 144.05,
    ry: 10.21
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 147.05,
    cy: 778.45,
    rx: 144.05,
    ry: 10.21
  })), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M192.91,602.98c-4.45,0-8.07-3.62-8.07-8.07V95.59c0-4.45,3.62-8.07,8.07-8.07h663.46 c4.45,0,8.07,3.62,8.07,8.07v499.32c0,4.45-3.62,8.07-8.07,8.07H192.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M856.37,88.11c4.13,0,7.49,3.36,7.49,7.49v499.32c0,4.13-3.36,7.49-7.49,7.49H192.91 c-4.13,0-7.49-3.36-7.49-7.49V95.59c0-4.13,3.36-7.49,7.49-7.49H856.37 M856.37,86.94H192.91c-4.78,0-8.65,3.87-8.65,8.65 v499.32c0,4.78,3.87,8.65,8.65,8.65h663.45c4.78,0,8.65-3.87,8.65-8.65V95.59C865.02,90.81,861.15,86.94,856.37,86.94 L856.37,86.94z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M865.02,137.82H184.26V95.59c0-4.78,3.87-8.65,8.65-8.65h663.45c4.78,0,8.65,3.87,8.65,8.65V137.82z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M715.32,114.34c0,3.96-3.21,7.18-7.18,7.18c-3.96,0-7.18-3.21-7.18-7.18c0-3.96,3.21-7.18,7.18-7.18 C712.1,107.16,715.32,110.38,715.32,114.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M762.77,114.34c0,3.96-3.21,7.18-7.18,7.18c-3.96,0-7.18-3.21-7.18-7.18c0-3.96,3.21-7.18,7.18-7.18 C759.56,107.16,762.77,110.38,762.77,114.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M810.22,114.34c0,3.96-3.21,7.18-7.18,7.18s-7.18-3.21-7.18-7.18c0-3.96,3.21-7.18,7.18-7.18 S810.22,110.38,810.22,114.34z"
  })))), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M350.81,442.41h317.27c1.16,0,2.1-0.94,2.1-2.1v-99.19c0-1.16-0.94-2.1-2.1-2.1H350.81 c-1.16,0-2.1,0.94-2.1,2.1v99.19C348.71,441.47,349.65,442.41,350.81,442.41z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M350.81,560.7h317.27c1.16,0,2.1-0.94,2.1-2.1v-99.19c0-1.16-0.94-2.1-2.1-2.1H350.81 c-1.16,0-2.1,0.94-2.1,2.1v99.19C348.71,559.76,349.65,560.7,350.81,560.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 509.4451,
    y1: 165.9583,
    x2: 509.4451,
    y2: 547.6746
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAF3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CEECFF"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M349.25,299.63h320.39c0.3,0,0.54,0.24,0.54,0.54v21.75c0,0.3-0.24,0.54-0.54,0.54H349.25 c-0.3,0-0.54-0.24-0.54-0.54v-21.75C348.71,299.87,348.95,299.63,349.25,299.63z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 588.1932,
    y1: 165.9599,
    x2: 588.1932,
    y2: 547.6685
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAF3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CEECFF"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "348.71,176.58 827.68,176.58 827.68,193.03 348.71,193.03  "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 222.42,
    y: 156.37,
    className: "st4",
    width: 103.54,
    height: 419.56
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2579 -0.9662 0.9662 0.2579 321.299 918.1949)",
    className: "st7",
    cx: 758.37,
    cy: 249.94,
    rx: 36.02,
    ry: 36.02
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 721.3383,
    y1: 302.5703,
    x2: 795.3945,
    y2: 302.5703
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAF3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CEECFF"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M793.07,304.89h-69.41c-1.28,0-2.32-1.04-2.32-2.32l0,0c0-1.28,1.04-2.32,2.32-2.32h69.41 c1.28,0,2.32,1.04,2.32,2.32l0,0C795.39,303.85,794.35,304.89,793.07,304.89z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 721.3383,
    y1: 318.5107,
    x2: 795.3945,
    y2: 318.5107
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAF3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CEECFF"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M793.07,320.84h-69.41c-1.28,0-2.32-1.04-2.32-2.32l0,0c0-1.28,1.04-2.32,2.32-2.32h69.41 c1.28,0,2.32,1.04,2.32,2.32l0,0C795.39,319.79,794.35,320.84,793.07,320.84z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 380.75,
    y: 403.65,
    className: "st11",
    width: 19.44,
    height: 23.6
  })), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 420.4,
    y: 378.56,
    className: "st7",
    width: 19.44,
    height: 48.69
  })), /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 460.06,
    y: 392.06,
    className: "st11",
    width: 19.44,
    height: 35.19
  })), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 499.72,
    y: 371.99,
    className: "st7",
    width: 19.44,
    height: 55.26
  })), /*#__PURE__*/React.createElement("rect", {
    x: 539.38,
    y: 357.84,
    className: "st13",
    width: 19.44,
    height: 69.41
  }), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 579.04,
    y: 366.05,
    className: "st7",
    width: 19.44,
    height: 61.21
  })), /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 618.7,
    y: 383.88,
    className: "st11",
    width: 19.44,
    height: 43.37
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M460.44,217.45v61.03c0,1.43-1.16,2.58-2.58,2.58H352.01c-1.43,0-2.58-1.16-2.58-2.58v-61.03 c0-1.43,1.16-2.58,2.58-2.58h105.85C459.28,214.87,460.44,216.02,460.44,217.45z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M563.35,281.05h-94.54c-0.69,0-1.24-0.56-1.24-1.24v-63.69c0-0.69,0.56-1.24,1.24-1.24h94.54 c0.69,0,1.24,0.56,1.24,1.24v63.69C564.6,280.5,564.04,281.05,563.35,281.05z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 622.9331,
    y1: 165.9599,
    x2: 622.9331,
    y2: 547.6714
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAF3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CEECFF"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M670.2,281.05h-94.54c-0.69,0-1.24-0.56-1.24-1.24v-63.69c0-0.69,0.56-1.24,1.24-1.24h94.54 c0.69,0,1.24,0.56,1.24,1.24v63.69C671.44,280.5,670.89,281.05,670.2,281.05z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M455.83,251.6v26.07H354.03v-12.49l15.43-11.57c6.71-5.03,15.92-5.09,22.7-0.14l13.35,9.75l17.49-17.49 c7.45-7.45,19.54-7.45,26.99,0.01L455.83,251.6z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 378.92,
    cy: 234.14,
    r: 7.61
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 362.8,
    y1: 472.7,
    x2: 656.14,
    y2: 472.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 362.8,
    y1: 490.85,
    x2: 656.14,
    y2: 490.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 362.8,
    y1: 509.01,
    x2: 656.14,
    y2: 509.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 362.8,
    y1: 527.17,
    x2: 656.14,
    y2: 527.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 362.8,
    y1: 545.32,
    x2: 656.14,
    y2: 545.32
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M372.85,530.26c0,0,9.49,11.54,27.51,8.8c18.78-2.85,25.44-38.06,47.03-38.06 c21.59,0,21.29,22.6,44.07,22.6s33.42-41.15,58.56-41.15c25.14,0,21.89,16.89,47.62,16.89s42.59-30.68,42.59-30.68"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M299.51,195.73h-50.66c-4.93,0-8.92-3.99-8.92-8.92l0,0c0-4.93,3.99-8.92,8.92-8.92h50.66 c4.93,0,8.92,3.99,8.92,8.92l0,0C308.43,191.74,304.44,195.73,299.51,195.73z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 248.8897,
    y1: 248.3521,
    x2: 299.4772,
    y2: 248.3521
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAF3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CEECFF"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M295.97,251.86H252.4c-1.94,0-3.51-1.57-3.51-3.51l0,0c0-1.94,1.57-3.51,3.51-3.51h43.57 c1.94,0,3.51,1.57,3.51,3.51l0,0C299.48,250.29,297.91,251.86,295.97,251.86z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 248.8897,
    y1: 282.4828,
    x2: 299.4772,
    y2: 282.4828
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAF3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CEECFF"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M295.97,285.99H252.4c-1.94,0-3.51-1.57-3.51-3.51l0,0c0-1.94,1.57-3.51,3.51-3.51h43.57 c1.94,0,3.51,1.57,3.51,3.51l0,0C299.48,284.42,297.91,285.99,295.97,285.99z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 248.8897,
    y1: 316.6136,
    x2: 299.4772,
    y2: 316.6136
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAF3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CEECFF"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M295.97,320.12H252.4c-1.94,0-3.51-1.57-3.51-3.51l0,0c0-1.94,1.57-3.51,3.51-3.51h43.57 c1.94,0,3.51,1.57,3.51,3.51l0,0C299.48,318.55,297.91,320.12,295.97,320.12z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 248.8897,
    y1: 350.7443,
    x2: 299.4772,
    y2: 350.7443
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAF3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CEECFF"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M295.97,354.25H252.4c-1.94,0-3.51-1.57-3.51-3.51l0,0c0-1.94,1.57-3.51,3.51-3.51h43.57 c1.94,0,3.51,1.57,3.51,3.51l0,0C299.48,352.68,297.91,354.25,295.97,354.25z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 248.8897,
    y1: 384.8751,
    x2: 299.4772,
    y2: 384.8751
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAF3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CEECFF"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M295.97,388.38H252.4c-1.94,0-3.51-1.57-3.51-3.51l0,0c0-1.94,1.57-3.51,3.51-3.51h43.57 c1.94,0,3.51,1.57,3.51,3.51l0,0C299.48,386.81,297.91,388.38,295.97,388.38z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M153.47,464.29c-27.82,0.79-14.12,26.72-8.91,49.5c9.52,35.79,4,82.17,18.42,87.26 c38.45,11.73,26.21-124.98,15.54-131.25C173.51,466.94,162.81,465.25,153.47,464.29z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M178.54,589.17c-26.97-19.41-24.95,109.89-17.78,146.25c7.17,36.36,14.84,11.7,20.21-46.35 C186.34,631.01,189.15,596.8,178.54,589.17z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "156.66,731.77 155.78,745.33 177.99,746.08 177.48,732.93  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M178.48,745.81c0,0,4.14,8.2,18.01,18.97c13.87,10.78,17.55,8.51,17.83,12.48 c0.28,3.97-61.11-0.08-61.11-0.08l2.24-32.56C155.46,744.62,178.48,744.96,178.48,745.81z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M123.76,464.67c-27.24-5.7-27.22,23.72-27.45,47.08c0.94,37.02-7.93,79.84,4.91,88.14 c34.67,20.34,45.95-119.95,37.03-128.53C134.04,467.42,132.62,467.78,123.76,464.67z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M115.78,588.55C88.81,569.14,90.83,698.44,98,734.8c7.17,36.36,14.84,11.7,20.21-46.35 C123.59,630.39,126.39,596.18,115.78,588.55z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "94.63,735.24 94.43,748.54 115.74,748.91 115.55,735.85  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M94.23,748.35c-0.33,5.25-5.98,23.16-6.15,27.72c33.87,1.19,32.85,8,27.73-27.4L94.23,748.35z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M101.68,465.49c0,0-9.04,15.33-8.74,64.82c0.35,56.59-0.29,69.86-0.33,74.03 c-0.04,4.17-1.02,133.41-1.02,133.41s21.13,4.55,26.28,0.21c2.69-2.27,24.94-205.58,24.94-205.58s4.09,48.26,5.28,66.56 c1.03,15.85,0.28,124.67,5.89,135.85c5.85,4.83,27.3,2.56,27.59,2.25c3.2-3.33,13.82-226.82,3.96-267.74L101.68,465.49z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M167.48,343.27c-15.3,9.78,4.41,101.69,16.21,96.87C204.34,441.74,195.19,332.52,167.48,343.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M150.08,328.8c42.38,5.32,41.22,42.53,44.67,69.06l-29.74,4.04L150.08,328.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M184.67,442.13c17.81-3.03,59.56-76.04,55.52-80.35C237.06,353.63,149.6,442.04,184.67,442.13z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M123.57,325.62c-56.85,7.23-17.06,40.11-23.83,140.97c-0.07,7.21,86.83,10.65,86.41,3.15 c-9.44-79.55,17.95-131.74-36.16-141.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M150.12,320.92l-0.15,15.01c-1.21,13.8-22.84-1.1-25.26-6.77c-1.67-3.65,0.8-5.49,0.88-13.18 c0.08-7.69,0.08-8.54,0.08-8.54c-25.82-41.04,17.25-57.74,33.73-28.62C159.45,302.55,165.62,324.95,150.12,320.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M93.95,342.02c-16.86,5.28-23.66,100.84-11.34,99.33C101.58,448.12,122.71,339,93.95,342.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M156.68,440.04l-55.69-9.41l8.19-38.83L78,388.12c0,0-6.52,52.13,2.76,62.45 c9.28,10.32,73.31,8.32,73.31,8.32L156.68,440.04z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M83.98,443.91c0.18,3.18,2.28,5.97,5.1,7.43c22.1,11.44,117.53,8.75,114.55,2.17 C203.54,448.38,82.59,420.02,83.98,443.91z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M124.11,325.62c0,0-30.49,1.28-36.51,11.05c-6.03,9.77-11.56,52.92-11.56,52.92l33.09,3.69l3.39-19.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M159.8,261.43c3.42,1.61,5.45,5.25,5.19,9.02c-0.36,5.21-1.98,12.35-8.23,11.74 c-9.75-0.95-19.45-5.66-22.81-1.83c-3.36,3.83-0.05,27.23,4.56,26.95c4.61-0.28,22.3-4.62,22.8-0.97 c0.5,3.65,2.21,19.34-4.88,20.77c-7.09,1.43-20.22-4.27-22.53-9.12c-2.31-4.85-3.16-10.59-3.39-15.09 c-0.22-4.5-1.12-11.32-4.39-11.19c-3.27,0.13,0.14,15.58-0.45,15.74c-0.59,0.16-9.86-14.02-8.62-25.42 c1.24-11.4,3.03-19.48,16.12-20.1C143.79,261.41,152.19,257.85,159.8,261.43z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 157.09,
    y: 443.6,
    transform: "matrix(1 9.861460e-03 -9.861460e-03 1 4.4024 -1.9036)",
    className: "st27",
    width: 76.29,
    height: 3.72
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "253.3,447.89 182.31,447.19 202.82,399 273.8,399.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st27",
    points: "255.3,447.91 184.31,447.21 204.82,399.02 275.8,399.72  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M235.72,425.93c-1.31,3.18-4.09,5.06-6.2,4.19c-2.11-0.87-2.75-4.16-1.44-7.34 c1.31-3.18,4.09-5.06,6.2-4.19C236.39,419.46,237.03,422.74,235.72,425.93z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M247.64,356.53c0.72,3.04,4.64,5.11,1.46,10.89c-3.18,5.77-13.75,7.2-13.75,7.2l-4.47-8.05 c0,0,1.73-2.31,2.05-3.76c0.32-1.45,2.37-6.72,7.64-9.08c5.27-2.37,13.53-4.81,14.56-3.26 C256.16,352.01,247.07,354.14,247.64,356.53z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M188.97,448.48l-1.05-0.75l2.49-1.58l0.02-0.01l4.43-2.54c1.14-0.64,2.41-1.01,3.71-1.04l5.65,1.24 c0,0,0.98,1.49-2.31,1.62c-0.86,0.03-1.99,0.81-2.88,1.48l3.24,0.3l7.88,1.33c2.02,0.33,4.24,2.35,3.96,4.76 c0,0-0.68,3.35-4.44,4.25l-5.12,1.71c-2.8,0.42-4.89,1.27-7.64,0.56l-7.3-2.55L188.97,448.48z"
  })))), /*#__PURE__*/React.createElement("g", null, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M840.57,645.45c21.16-17.7,48.28,63.32,53.9,98.18c5.62,34.86-13.58,3.37-38.39-46.54 C838.54,661.83,830.61,653.79,840.57,645.45z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "900.66,746.85 893.36,731.53 872,738.76 882.14,756.01  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M900.66,746.85l1.97,6.87l-16.01,13.65l-14.58,1.46l6.48-5.54c0,0,4.06-4.21,3.62-7.28 C881.7,752.94,900.66,746.85,900.66,746.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M901.45,749.08c0,0-9.16,18.4-22.93,14.2c0,0-15.1,8.9-13.15,13.75c1.96,4.85,12.38-0.79,12.38-0.79 l29.65-12.43C907.42,763.81,907.08,756.27,901.45,749.08z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M912.91,681.42c-44.71-7.94-79.61-21.98-77.94-31.37c1.67-9.39,39.27-10.57,83.98-2.63 c44.71,7.94,60.34,15.64,58.67,25.03C975.94,681.84,957.62,689.36,912.91,681.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M962.59,653.46c0,0-58.78-11.46-75.54-14.4c-16.75-2.94-48.79-7.94-55.55,8.82 c-6.76,16.75,40.85,104.63,40.85,104.63l27.04-13.23l-22.63-61.72c0,0,81.41,26.16,96.4,9.41c14.99-16.75,5-35.27,5-35.27 L962.59,653.46z"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M901.44,562.15c2.84,3.46,3.07,8.39,1.21,12.44c-8.36,18.17-40.36,91.6-54.08,86.2 c-16.13-6.35,17.39-70.59,27.65-84.56C884.77,564.6,894.58,553.79,901.44,562.15z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st33"
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M877.31,679.3H679.97c-1.39,0-2.51-1.13-2.51-2.51V354.37c0-1.39,1.13-2.51,2.51-2.51h197.35 c1.39,0,2.51,1.13,2.51,2.51v322.42C879.83,678.18,878.7,679.3,877.31,679.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 214.02,
    height: 339.1,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANcAAAFUCAYAAAC3Lql3AAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAEa1JREFUeNrsnVGy27YVhnlAOc9e gjvT5453EGe6gLYrSLqDeAVtd5AdxFlB2vdOm66gmU4f26mX4Hdf8RSkSIoiARAgAN1r3+9zbq6u REkUxZ//f0AQkMZB1+k3TaO/UW1ea6OvmgTU/kjCsk3C8k3i6y7/kJpvIoXXOXjnluGzrZcNrJPY fwmLF95s6v9s4v5DjryHrvZFmT65f53s/j7uJ5flpvsv20uHx43I9X6RD3a5n+3Nv9ifd8aYD96P o6qvrbC+7+xve7uxv4cXvKzo/IL9ctevSabH5LJ28xcutxtzejtVzw4i/i8iuNOJ+5uSlbj6OyTh y09ClhvRs3k1TSXaPGnEtzF3trGqFlsD31vGfYey2Ht8Stfg0/tt0IvNmOH3B3vzrRXYu816DYLq 9O8PXffSCqw5d92wn+ggsOsxoF8Rcdw+6l5QfF875oBy3DmTvmwtaPo567zST2if1dWxWmZxXUyh F1drf07G9Ld/PwlMxqNJL6j/PZy7l72o7G8rrotzTUcbCTi5eo9smvD9yM2RRyK3lSTtP2nfhmZ9 77dbptzxWqL8Vgq/b7KDFU0Gae8d+x5Lk3BHZ931vT5stFZUbWvF1Zrhx7rYV1ZgP51G8XxrRTUL aymupY1rgkelfbnq3FTlvobar1+/UvHtTo/5GeToJ/FFw8TC2HeonMwg+jXVU5hfi7D59rosHGqw wY1l/GdvneR7++gvhmXPVkkfH87Nx/NVXA/nc/MwCKy7+tNUJC5Kp8kidfVNy6qGUN/eIMtGB3eN ojv7nLjKMMeTZXdDa5KDSaABJXoHEcdTQlFfpNj6ewWSUPZJ7IcsXnN56nTVZGEeqLgGemG1vVsZ M7vWF6d2+G1j4lcnuzJvbJ3V2AqrmWqt/qcX2kcrsN7BcqsorbBkvWPv/b3g3vWpFoh3hdsOH3k9 jq11L64X2lqnGh1MLhpSM+jlzSAu7e/omrm58awXkT2MMbHTTydAldjh5DH2bnicI82Rr29okm+s Q7X2d68P00yt61MLu/358rRsBZw1pM1lwdnJ1Nsy+Gntd/p5Hg2q7ujy6B8qd78r2fg/nXZq+/rL CqtvJVxH0cnZTtsPoPPqdDr9TE3zWu1DSKV9TQp8AYLuPtltUXq79p/fDE3uptEbxeim5jtNd093 6rJtamzL7x97GB2s6teu5V9VqjVKf2K7GScei+TBXlQvJG5fOs27X8TG793LRsX39ub753S0+izj Z4lVFHlexwFp3nyx+5llKa7EzKn6w69/9cs/chiD58bf/v1f3Vf+9ahl5rRICxZAAfeXpbjk/o1C AJ8rcv1tUoWKwQEEakS9dm8xbBqACumwGcWFGwGUxzSLqzABoKi4ZLzoi40BULIQIxYCpBRXO2JZ XgZjRpEBwHGTWuhv1Vqou08BgLWJuW4v/8C5ADIF5tOP8UuSSgwg1cU24lLSIMChWksCl3LSQwOg nnNp3JIAkITxV2fkQ4B46xKXuHyXnGBhANHFl0Mv1FwARdQ1DnA99dAQTiIDFMqFujmZHDiJTCwE SE6Hiz/ouAtQUFQa51zEQoC4UOie1sHsPxFfA4hWybrjrvsyFUQFEIyCEs55cyyUyFhIWASI0IQE nQsA1oJxTrjXuCcw3DoXl5wAHNCduGMhuQ/gGNc5Vz3dn9wzwaMygFiBuXKe8zyXEgsBUssxv3MV m7kd4Dlal6/mEp9wGIYXYN90/JecbHvz1proFOAzsanYmks2vXkRFUCa3jxN8fQeBKiB2ZRXswq9 lRgArNKep+ZazXIik5fhZwD7FVeEcwFAhnFFdX9aPWX9JPwMwKcVxxRCNSwR4FlHRSEWAhSS13bk ahPpdgCQ6GCGEAhQRlgSLy4AiEXSai4yIcAhYcU6FxIDWGQ/DatkMygoAORpzvUX4gIoIC89EgsB 4ICDyU5TPPUWQDw3neOVWU4ACgkrMIaGR4cAsBMGL8Ji2laAu4G4AAq4l1tc49X8SiAEOCwtd1O8 +oYnpJkDIDsWrmc5QVYAabiaNKi5AArJa/+SE6HyAsiT1UJcxECAHNxNGsaXHwEgLKfQ37O4EBNA VP7zzonsjYXuhQmLADkYz7SSAJBkaq6Ou7oqx8iIAIWcKxQwASCmFPOLK3ayIOQGkOlciAjAh260 4msANCgJIDEGSpxoTN8l3n1CjGZDgGN+NsdC2V8KAILKihtDg5gIUARqLoDsGiyh5opvnAeApL6F yAqgRCyc1BfRkKE0dgBE+9fcWig3i3nGs8HSAAmlOZcEhKO0zQNsfUYixeV5OlsQIEZoHr0w+hNA dj6UVOcCgPS4KHM5hbgASprY7GWCuADqOBixECDfpjyLIS6AbGEFBgXlTBZAeb0Z/0JKfyeADIID 1CjnkQGiHYwphADu6VwAkI8gLoD6wkJcABXVttMrnhYNgH0d0XEX4K6YGF0CQCK66KHB6WKASs6F PwEcNqnFbb0VF8ICiEDiJ2GIrLkAIN67EBdAdXkFR9zlTBfAcYEZ/0K0HwIcL84SYyEuBhBjXzo6 15z9kA7Aserq0gVKVouZ6xlkYiBASeihAVC63lqKiwoLIEdO0nhHf6LJHaBSLAQAxAXw5FHEBVBa TosaTBInHGeMUICtnLat7ZuTyABwwKi8y5iU5QEgHsOQ8AC1xOV1PY0vxgBIhH5xoRuAsvLbjqFB RARIxjUwKOe5AO5Wc5EPASqJC5UBZEfCi7jQEEAmDK0GkK8hjReY4XQWQMWai9Z3gEriAoDyVRfi AqggrFlc1FgAd42FVGIAOcowyAqglnORCQGykSjnwrYAishr9zJ/RW0AUU61FZeuhCUJzwZ4bqJy zIksXnFlaRMAu2rSxQUAOTCGBkBNcQmBEKCec1WInACfIb7Bq3V9ByeRAYojB5wLALJjoYxjXHMC GeC4uHTbB0P9A1oDgKcSi3QuR4AEgNRYiHgAcm2LXvEA1WCseIB7xsKV5sRTrDFJHoDbs8QnLkou gHrO5c6PzEQOkCWuaPmgMwAn3nELdaeQwr8ADjoXnZwA7hgLvcNoYGEA8eJiEwDk11fu+bmmh8iG AAWQsHNpQyUGkOttZpouWainAO5Vc6E2gEriAoC4Kst9NhhxAaSUUwlNEYgLoIDmZhcbGy/6RkHE BZApKGdUtCJDXACVQFwAlbwMcQFUColmeoj+GABl9TaPocEpY4Cy/mVSrQ4A4tRCzQWQQErCQ1wA 0coSbw93V2lFx12AGhFRcC6AAlFRnLbEtK0ASZ6ka4+i5gK4N4gLID0HRpkcPTQAMlV2GxT11rno oQFALARAXADPB43v/iSxRRsAOKQWEJduyjQAiBXVZE7EQoDiSGLNpXgZwK6k9CoWQzs8QAlhuQYF VWY4AaiBWRdj69yohEGACNfShWoW4iIZAhyor2KdCwAqxUIAQFwATwx1/mX286TEh0yAZyotvXEs oYcGQB2xcRIZoHLNNXoaZ7MAUqurPXE5nkCveIASzlVCogCwkY23h4Y2dH0CiMXdcdcjPdo4APLS nHFI0PcHABSpuQDgcCTkJDJAkWiozrvMXvIjGAIUjIUICiDf0gy9MwDu6Fw4GEC+Jpi2FSBWWJ45 kX2zBBlkBPAIsRAvA4jxqARx0Sse4M7OBQAp4iLrAWST1CseABJKMadz6epxnAwgSU8igZpLPUYH ADk1FwDkpD/EBfBozkUIBKggLqHaAsiMi0osBLhXcRZ9Elm57gsgDgk6F8EQINqiQjWX+0n4FECO zEyf9zRiQbwMIA2DbADybUuiYiFpEOAAMb3iyYEAxwuttbgYHh7guKiCveIBoDyek8hMlAyQL67j 9RoABEovg2YAjiESVo9RZXJWgCqxkN4YAPkRkFgIUE1oXM8FcL9YOOtO1yqkEgPIiYtzD4254YOL IgGSCy5Px13xLEU1BhCDeDpdUHMBFDS06dxXf4ILcQFUyIy9yEzaUwBgWzS5VTKPFb95WJEVwNqN xNMWsdGQLlsLw9L03QXwzKJf5rStSAkgLSJuDEpoLQQoXoFFOBcAxIZF152Bye8AIFVeywu4vLOc UHEB5LmX8S3IJZQAGQKjQQOgHLJUmDLhOEARUUlSx13G1gBIkJduTMngUQBFq635L7MXCBEewL60 dK0ZmUbcRUEAxRVnhsv6V5f2+844U4MBxGM28U+JhACpiMOaaNAAyBZW7BgaKA0gvcByxkIuigSo IjBDQwVAvqyiO+4CQD7OBg2cDKCEuFAWQHJVtR7pyd1xV1cL05oBkIRvgkkuOQGoWXOtpYSsAI7F xY24osSE4gCSJGb8oqFlAyDHvYzrimNkBZCfC7eT36EsgGSEye8AypuUvyletgPIMywoQLzSgq2F AFAeZ4MGngUQmQkDD87OpRr9KgAQ5VwOt0JaAKlW5mwtlGsbxg7ERXjO+OdElnAsTAyYAM/UqdR5 vy4EOOmN1kKACiFxnuWEEAiQERddg6sJ07YCFHAsXUzLpbfO5fQoQXIAh2Nhw5XIAGVjoa7EhYwA jqhKbqOgy7nc7kUsBDgaCW9iIe4FkBMNPeIST44EgOM4GzQkkCMBICEWMuguQKVY6BYUsRAgR17O Bg3nRf5MNQSQFAy9sXBdcyEsAL+ugk3xqAjgeCL0Dq3G6E8A5TGuRnex9wh1FkDIrOJqruEhDSdD fAwg2bnGHr2bUa3xLIBYNpf5N4ErkXEqgPSYuJyh1fiViLwAUp1rrq80eLEksRAg1bmWt4xfU0I2 BIiwG/EsZfxL4lwAsaLz9tBYS0k2/weAkLqCveK3Y8XjXACJBZdbXLcqFK5EBsjEbKbHk3GQw37e Lt1XJwB4xSWIByC/7NroyDtADSNCAeSoLHCeC2EBxAvK21rInMgAxxF/a6HejnEtNMIDRKS+4H2j uOTyINO2AqQrK8DJJRrxqGls5Pj6r//6z5fRlpm3fnez8Hn9MlbwSR18xml6Yy981Uqr8Plkv/QP dNqc5wrZnN0zzal9ZW++2i7vmYhod28ucbDQ6C0kNb5xT9HqE+qwDrq8HFWCe6VkrJdGdjct8FD6 6mnEQU/Xn0CiVkoqaizJuXTx6dYCnT5Y289k3rbBF9c9p9D6+/Vh5/pECk1N2AGe4kc6sjvIkT07 8YC3PN2rrhZzuUa33jBiBtE9XQeFcnfH6HfG1hivA6kGps7LtQktO9iAiNxZCL7u0LD1VPlkImW/ G/UpTnbWfI6FN4uO6uxfoBUrLKONcVybrKGjRsblYFr2O1x+rCfrQFJgWXUcaKval6QtplrprSV9 X5LE72jtuO2oj8sBe6GeaQxD+9/JPviT/fnDrMbxd+9WJyuq/m+XO+1tKLNwiSP+o1r+aOPrjBxT l0iTWr/ENyVoteO2urdjcjYTb7w+3v1Ul8e9xN1fPT2I6h8+p/1gMp+T1UlrLroRmX4Pi/48iOt8 Pl8aK+xCppNh4RetGV7o3InjcOhumYouBKRJKx5iDkGatkuXKQIOFkSa+NrbvtVFD/2qj+Tqqdsx db/J+T5ktcFXCWhwr0FYlx8j5qKh0c3sMv84jbXIOyusby7CMvPr9At2aigPnglP4bRJyfavkg07 Iu7qajAkuRhS28ooNPlgH/xpWLrruled6j8fzt3L81kb+9s6VmeFpc6oJisl62prTOvhbXXZlmdb m98pNGIP/lFH5YjMLk3YPW7iUa4DRry/6+AaitRSaH1i1lcct2/Wfa//qhx7X++2l8jnSODDBMqf doyGrU17p3a4/TtjzJ/np3ad/rbT7sdeXL2wzp329zE4KIDXzS4XFZ/aq8Csk31nhfV2o1Urpjeq +qN1rJeDc3UX6XoFpns2mtCKU1vDklcqlX3iHT+bHnu9oGUWXE8tUaf6GloSnqO6U2st/p7eY6yt LtHQyAfrYn+ywvrOa5hWXC/tz7f2zb62onp1uxF0bmZc72SaKK5D+7Ie2f+vpxrufJqreItnStSc Puo62hcbvkEyBHdzwnbZapi/biJXYem0v1ZzrmGd34/11VsrrA9J6dbWY6/tr5eEAIANP68FteT/ AgwAwkJXf/53AcgAAAAASUVORK5CYII=",
    transform: "matrix(1 0 0 1 671.6279 346.0301)"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M889.73,666.48H692.38c-1.39,0-2.51-1.13-2.51-2.51V341.54c0-1.39,1.13-2.51,2.51-2.51h197.35 c1.39,0,2.51,1.13,2.51,2.51v322.42C892.24,665.35,891.11,666.48,889.73,666.48z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M791.05,400.87c-37.25,0-67.45,30.2-67.45,67.45c0,37.25,30.2,67.45,67.45,67.45 c37.26,0,67.46-30.2,67.46-67.45C858.51,431.07,828.31,400.87,791.05,400.87z M791.05,512.43c-24.35,0-44.1-19.74-44.1-44.1 c0-24.36,19.75-44.1,44.1-44.1c24.36,0,44.11,19.74,44.11,44.1C835.16,492.69,815.41,512.43,791.05,512.43z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M858.51,468.32c0,18.33-7.32,34.97-19.21,47.12l-16.5-16.5c7.66-7.94,12.36-18.73,12.36-30.62 c0-24.36-19.75-44.1-44.11-44.1v-23.35C828.31,400.87,858.51,431.07,858.51,468.32z"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M733.26,356.6h-30.39c-1.16,0-2.11-0.94-2.11-2.11l0,0c0-1.16,0.94-2.11,2.11-2.11h30.39 c1.16,0,2.11,0.94,2.11,2.11l0,0C735.37,355.65,734.42,356.6,733.26,356.6z"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M737.12,593.23h-30.39c-1.16,0-2.11-0.94-2.11-2.11l0,0c0-1.16,0.94-2.11,2.11-2.11h30.39 c1.16,0,2.11,0.94,2.11,2.11l0,0C739.23,592.28,738.29,593.23,737.12,593.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M875.38,593.23H757.5c-1.16,0-2.11-0.94-2.11-2.11l0,0c0-1.16,0.94-2.11,2.11-2.11h117.87 c1.16,0,2.11,0.94,2.11,2.11l0,0C877.48,592.28,876.54,593.23,875.38,593.23z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M737.12,613.52h-30.39c-1.16,0-2.11-0.94-2.11-2.11l0,0c0-1.16,0.94-2.11,2.11-2.11h30.39 c1.16,0,2.11,0.94,2.11,2.11l0,0C739.23,612.57,738.29,613.52,737.12,613.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M875.38,613.52H757.5c-1.16,0-2.11-0.94-2.11-2.11l0,0c0-1.16,0.94-2.11,2.11-2.11h117.87 c1.16,0,2.11,0.94,2.11,2.11l0,0C877.48,612.57,876.54,613.52,875.38,613.52z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M737.12,633.81h-30.39c-1.16,0-2.11-0.94-2.11-2.11l0,0c0-1.16,0.94-2.11,2.11-2.11h30.39 c1.16,0,2.11,0.94,2.11,2.11l0,0C739.23,632.86,738.29,633.81,737.12,633.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M875.38,633.81H757.5c-1.16,0-2.11-0.94-2.11-2.11l0,0c0-1.16,0.94-2.11,2.11-2.11h117.87 c1.16,0,2.11,0.94,2.11,2.11l0,0C877.48,632.86,876.54,633.81,875.38,633.81z"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M925.94,566.11c-3.88-2.23-5.85-6.75-5.54-11.2c1.37-19.96,5.22-99.97,19.96-99.79 c17.33,0.21,8.8,72.16,4.16,88.87C940.66,557.91,935.33,571.49,925.94,566.11z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M946.06,476.97c2.18-3.72,1.83-8.41-0.24-12.2c-9.68-17.7-44.66-80.53-53.35-79.73 c-10.11,0.93,36.39,94.33,41.75,94.95C938.24,480.45,943.09,482.05,946.06,476.97z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "914.36,408.9 901.81,392.45 889.76,393.77 900.53,418.96  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M891.18,393.81l-1.4-0.05l-0.02,0.01l-0.01-0.02l-3.5-4.34c-0.89-1.12-1.5-2.43-1.76-3.83l0.37-6.3 c0,0,1.44-1.31,2.15,2.21c0.18,0.92,1.21,2.01,2.09,2.86l-0.23-3.55l0.09-8.73c0-2.24,1.81-4.98,4.46-5.08 c0,0,3.72,0.16,5.34,4.06l2.72,5.22c0.93,2.95,2.2,5.06,1.92,8.14l-1.5,8.31L891.18,393.81z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M912.98,551.79l12.72-77.88l-27.41-56.52l16.64-10.26c0,0,32.71,40.33,36.48,55.44 c3.78,15.1-7.43,103.53-7.43,103.53l-28.61,1.59L912.98,551.79z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M859.65,655.17c-1.77,3.93-5.79,6.37-10.07,6.89c-20.03,2.4-91.5,10.4-95.89,2.86 c-5.11-8.77,97.93-25.15,101.54-21.14C857.95,646.78,862.07,649.8,859.65,655.17z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "817.01,668.19 768.75,669.54 765.88,657.69 815.09,647.07  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M766.38,659.03l-0.49-1.31l0-0.02l-0.02,0l-5.23-1.94c-1.35-0.49-2.78-0.65-4.19-0.46l-5.86,2.35 c0,0-0.79,1.78,2.78,1.33c0.93-0.12,2.29,0.51,3.37,1.08l-3.44,0.91l-8.25,2.85c-2.12,0.71-4.15,3.29-3.41,5.84 c0,0,1.33,3.48,5.54,3.78l5.82,0.92c3.09-0.05,5.5,0.49,8.33-0.76l7.41-4.06L766.38,659.03z"
  })))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M878.2,565.1c0,0-16.69,33.38-22.25,46.3c-5.56,12.92-13.11,28.61-13.71,28.81 c-0.6,0.2-44.71,9.14-44.71,9.14l1.19,21.06c0,0,56.63-0.6,64.78-10.73c8.15-10.13,39.54-68.16,39.54-68.16L878.2,565.1z"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M863.72,753.53c-18.38-27.43,117.61-25.48,152.24-18.61c34.63,6.88-1.61,13.49-57,19.78 C903.58,760.99,870.95,764.32,863.72,753.53z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "1024.31,731.87 1006.36,731.91 1005.51,754.96 1025.36,752.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M1022.01,731.87l7.09,0.92l6.17,20.11l-4.45,13.96l-2.51-8.15c0,0-2.25-5.4-5.24-6.21 C1020.07,751.69,1022.01,731.87,1022.01,731.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M1024.37,732.03c3.05,3.62,16.32,12.09,3.93,26.68c0,0,2.17,17.39,7.4,17.52 c5.23,0.13,4.19-11.68,4.19-11.68l0.37-32.15C1040.26,732.4,1033.21,729.71,1024.37,732.03z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M933.28,708.54c-32.45,31.77-64.17,51.99-70.84,45.18c-6.67-6.82,14.23-38.09,46.68-69.86 c32.45-31.76,64.17-51.99,70.84-45.17C986.64,645.5,965.74,676.78,933.28,708.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M929.09,655.52c0,0-34.68,34.98-47.91,53.2c-13.23,18.22-31.25,40.17-20.57,56.43 c10.1,15.38,144.57-6.41,144.57-6.41v-31.15l-80.2-1.53c0,0,106.98-53.79,69.4-106.24l-45.29-2.51L929.09,655.52z"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M885.21,560.52l-1.13-12.79c0,0-11.87,0.21-15.24-9.54c-3.37-9.75-5.85-33.98-0.45-42.99 c5.4-9.02,43.46-10.37,48.2,14.83c4.74,25.2,2.55,55.37,2.55,55.37L885.21,560.52z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M994.37,619.82c-28.73,6.73-65.29,35.71-65.29,35.71s-14.81-19.38-28.34-37.29 c-2.53-3.32-4.97-6.58-7.28-9.66c-7.71-10.27-13.8-18.52-14.53-19.96c-5.3-10.39-2.62-19.29,1.1-26.84 c4.08-8.35,11.85-14.62,19.35-20.11c15.75-11.52,31.17-11.15,39.3-4.3C950.71,547.49,994.37,619.82,994.37,619.82z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M900.74,618.24c-2.53-3.32-4.97-6.58-7.28-9.66l5.61-10.3L900.74,618.24z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M901.63,586.32c-5.95-3.74-11.11-8.65-14.74-14.13c-5.84-8.8-10.28-24.42-2.95-33.83 c2.24-2.88,3.51-5.54,3.96-8.01c0.45-2.47,0.08-4.74-0.94-6.82c-2.04-4.17-10.46-0.92-14.45-6.26c-3.99-5.34-7.49-8.04-7.8-14.38 c-0.31-6.34,2.21-18.61,25.72-17.76c23.52,0.85,33.21,13.22,37.61,28.91c1.65,5.88,5.76,11.83,10.14,17.86 c4.5,6.18,9.07,12.48,12.19,19.5c3.11,7.01,4.45,14.75,2.4,22.25c-0.69,2.54-1.74,5.04-3.2,7.48 C939.53,597.96,915.9,595.27,901.63,586.32z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st36"
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M595.36,184.58H429.38c-1.91,0-3.46-1.55-3.46-3.46V15.14c0-1.91,1.55-3.46,3.46-3.46h165.98 c1.91,0,3.46,1.55,3.46,3.46v165.98C598.82,183.03,597.27,184.58,595.36,184.58z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 457.9185,
    y1: 98.1296,
    x2: 566.8263,
    y2: 98.1296
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#06449B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#004AA9"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M512.37,43.68c-30.07,0-54.45,24.38-54.45,54.45c0,30.07,24.38,54.45,54.45,54.45 c30.08,0,54.46-24.38,54.46-54.45C566.83,68.06,542.45,43.68,512.37,43.68z M512.37,133.73c-19.66,0-35.6-15.94-35.6-35.6 c0-19.67,15.94-35.6,35.6-35.6c19.67,0,35.61,15.94,35.61,35.6C547.98,117.8,532.03,133.73,512.37,133.73z"
  })))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M566.83,98.13c0,14.8-5.91,28.23-15.5,38.04L538,122.85c6.18-6.41,9.97-15.12,9.97-24.72 c0-19.67-15.94-35.6-35.61-35.6V43.68C542.45,43.68,566.83,68.06,566.83,98.13z"
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    className: "st39"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -152.95,
    y: 124.41,
    className: "st40",
    width: 60.2,
    height: 69.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: -89.27,
    y: 124.41,
    className: "st41",
    width: 60.2,
    height: 69.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: -153.93,
    y: 200.24,
    className: "st42",
    width: 60.2,
    height: 69.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: -90.25,
    y: 200.24,
    className: "st43",
    width: 60.2,
    height: 69.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: -153.84,
    y: 279.14,
    className: "st44",
    width: 60.2,
    height: 69.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: -153.04,
    y: 356.12,
    className: "st45",
    width: 60.2,
    height: 69.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: -151.95,
    y: 431.88,
    className: "st46",
    width: 60.2,
    height: 69.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: -90.73,
    y: 279.14,
    className: "st47",
    width: 60.2,
    height: 69.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: -88.73,
    y: 356.27,
    className: "st48",
    width: 60.2,
    height: 69.7
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout2);
export default __webpack_public_path__ + "static/media/about-2.e371d23505b5c11370859d954e245819.svg";
export { ForwardRef as ReactComponent };